import {Component} from '@angular/core';
import {GetRessourceNumeriqueListingGQL} from "../../../../graphql/generated";
import {map} from "rxjs";
import {extractEdgesAndNodes} from "../../graphql/operators/extract-edges-and-nodes";
import {TreeNode} from "primeng/api";
import {RessourcesNumeriquesService} from "../../services/ressourcesNumeriques.service";

@Component({
  selector: 'app-ogrn-play-list',
  templateUrl: './ogrn-play-list.component.html',
  styleUrls: ['./ogrn-play-list.component.scss']
})
export class OgrnPlayListComponent {
  ressources: any;
  ressourcesFormatted!: TreeNode[];

  constructor(
    private service: GetRessourceNumeriqueListingGQL,
    private ressourceNumeriqueService: RessourcesNumeriquesService
  ) {
  }

  ngOnInit() {
    var self = this
    this.service.watch().valueChanges.pipe(
      map(result => result.data.getRessourceNumeriqueListing),
      extractEdgesAndNodes()
    ).subscribe({
        next: values => {
          this.ressources = values
          this.ressourcesFormatted = []
          var ressourcesChildren: any = {}

          values.forEach(function (
            value,
            key
          ) {
            var articleId = value.ouvrage.BaseArticle.id
            var idPage = value.pageAtterrissage !== null ? value.pageAtterrissage.idPage : 'undefined'
            var titrePage = value.pageAtterrissage !== null ? value.pageAtterrissage.titre : 'Sans page'
            var titreOuvrage = value.ouvrage.BaseArticle.TitreWEB

            if (typeof ressourcesChildren[articleId] === 'undefined') {
              ressourcesChildren[articleId] = {'key': articleId, 'label': titreOuvrage, 'icon': 'pi pi-fw pi-inbox', 'children': []}
            }

            if (typeof ressourcesChildren[articleId]['children'][idPage] === 'undefined') {
              ressourcesChildren[articleId]['children'][idPage] = {'label': titrePage, 'key': idPage, 'icon': 'pi pi-fw pi-file', 'children': []}
            }

            var type = value.medias !== null ? 'url' : 'pouet'

            ressourcesChildren[articleId]['children'][idPage]['children'].push({'key': value.id, 'label': value.titreEditeur, 'icon': 'pi pi-fw pi-file', 'type': type, 'data': value.id})


            // if (!self.ressourcesFormatted.some(function (el) {
            //   return el.key === articleId
            // })) {
            //   var titreOuvrage = value.pageAtterrissage.ouvrage.BaseArticle.TitreWEB
            //   self.ressourcesFormatted.push({})
            // }

          })

          Object.entries(ressourcesChildren).forEach(function callback(entry: Array<any>) {

            const value = entry[1]
            const id = Number(entry[0])
            let pages: any = []

            Object.entries(value.children).forEach(function callback(entryPage: Array<any>) {

              const valugePages: any = entryPage[1]
              pages.push(valugePages)

            })
            value.children = pages

            self.ressourcesFormatted.push(value)
          })

        },
        error: err => {
        }
      }
    )
  }

  downloadFile(idRessource) {
    // let queryString = 'id='+idRessource
    // console.log(queryString)
    // this.location.go(`${environment.apiUrl}/api/ressource_numerique/download_asset`, queryString)

    this.ressourceNumeriqueService.downloadAsset(idRessource).subscribe({
      next: (data) => {
        let blob = new Blob([data.body]);
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = data.headers.get('filename')
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      },
      error:
        (err) => {
          console.log(err)
        },
    });
  }


  expandAll() {
    this.ressourcesFormatted.forEach((node) => {
      this.expandRecursive(node, true);
    });
  }

  collapseAll() {
    this.ressourcesFormatted.forEach((node) => {
      this.expandRecursive(node, false);
    });
  }

  private expandRecursive(
    node: TreeNode,
    isExpand: boolean
  ) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode) => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }
}
